export default __webpack_public_path__ + "static/benefitImg-4d13b2c644935b1c727359b7e804f60a.png";